import { Component, OnInit, ViewChild } from '@angular/core';

import { QuizService } from '../services/quiz.service';
import { HelperService } from '../services/helper.service';
import { Question, Quiz, QuizConfig, QuestionList, CompleteQuiz } from '../models/index';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { IfStmt } from '@angular/compiler';
import Swal from 'sweetalert2';
import { MapOperator } from 'rxjs/internal/operators/map';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.css', './quiz-ui.component.css'],
  providers: [QuizService]
})
export class QuizComponent implements OnInit {
  @ViewChild('f') f: any
  quizes: any[];
  completeQuiz: CompleteQuiz = new CompleteQuiz(null);
  quiz: Quiz = new Quiz(null);
  mode: string = 'quiz';
  others: any;
  currentIndex: number = 0;

  selectrole: any;
  radioSelected7: any;
  radioSelected8: any;
  radioSelected9: any;
  radioSelected10: any;
  radioSelected11: any;
  OtherSelect: boolean = false;
  quizName: string;
  SkillRating1: any;
  SkillRating2: any;
  SkillRating3: any;
  SkillRating4: any;
  SkillRating5: any;
  RoleRating: any;
  skill1: string;
  skill2: string;
  skill3: string;
  skill4: string;
  skill5: string;
  role: any;
  role1: string;
  role2: string;
  role3: string;
  role4: string;
  questionaryID:any
  referenceVal:any
  proficiencyLevels = [
  { name: 'Beginner', description: 'Basic knowledge or limited experience.' },
  { name: 'Familiar', description: 'Some practical experience and familiarity with core concepts.' },
  { name: 'Proficient', description: 'Solid understanding and ability to perform tasks independently.' },
  { name: 'Expert', description: 'Advanced expertise and the ability to mentor others.' },
  { name: 'Master', description: 'Exceptional skill with extensive experience and thought leadership.' }
];
  // config: QuizConfig = {
  //   'allowBack': false,
  //   'allowReview': true,
  //   'autoMove': false,  // if true, it will move to next question automatically when answered.
  //   'duration': 0,  // indicates the time in which quiz needs to be completed. 0 means unlimited.
  //   'pageSize': 1,
  //   'requiredAll': false,  // indicates if you must answer all the questions before submitting.
  //   'richText': false,
  //   'shuffleQuestions': false,
  //   'shuffleOptions': false,
  //   'showClock': false,
  //   'showPager': true,
  //   'theme': 'none'
  // };
  show: boolean = false;
  email: string;
  name: any;
  checkRelation: any;
config = {
  allowBack: true
};
ratingLevels = [
  { value: '5', label: 'Master', title: '5 stars' },
  { value: '4', label: 'Expert', title: '4 stars' },
  { value: '3', label: 'Proficient', title: '3 stars' },
  { value: '2', label: 'Familiar', title: '2 stars' },
  { value: '1', label: 'Beginner', title: '1 star' }
];

  showres: boolean = false;
  roleSelection: any = undefined;
  response = new SaveReferenceApproval();
  pager = {
    index: 0,
    size: 1,
    count: 1
  };
  starsCount: number;
  questions: ReferenceQuestion[] = [];
  answers: { [questionId: number]: string | number } = {};
  companyList:any;
  isCustomCompany:boolean = false;
  showProficiencyLevelsFlag: boolean = false;

  uniqueCode = 'ABC123';
  questionnaireId = 101;
  relation = 'Colleague';

  starsCounts: number[] = [];
  // showQstns:boolean=false;
  constructor(public toastr: ToastrManager, private quizService: QuizService, private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      console.log(params);
      if (params['refId'] != null) {
        sessionStorage.setItem('refId', params['refId']);
        localStorage.setItem('stateOfUser', 'abcde');
      }
    });
    // this.quizes = this.quizService.getAll();
    // this.quizName = this.quizes[3].id;
    this.quizName = sessionStorage.getItem('refId');//'F3C4F5'; //'1BE3D2';'7AC0E0';
    this.GetReferenceReasons(this.quizName);
    this.loadQuiz(this.quizName);
    this.loadQuestions(this.quizName);
  }
// determineInputType(q: ReferenceQuestion): 'dropdown' | 'radio' | 'rating' | 'textarea' {
//   const count = q.answerChoiceList?.length || 0;

//   if (count === 0) return 'textarea'; // No choices = open-ended

//   if (count === 5 && q.caption.toLowerCase().includes('rating')) return 'rating';
//   if (count <= 3 || q.caption.toLowerCase().includes('select')) return 'radio';

//   return 'dropdown';
// }


nextQuestion() {
  if (this.currentIndex < this.questions.length - 1) {
    this.currentIndex++;
    
  }
}

prevQuestion() {
  if (this.currentIndex > 0) {
    this.currentIndex--;
  }
}

loadQuestions(uniqueCode: string) {
  this.quizService.GetReferenceQuestionsUpdated(uniqueCode).subscribe((res: ReferenceQuestion[]) => {
    this.questions = res.map((q:any) => {
      this.checkRelation = q.questionnaireId;
      this.uniqueCode = uniqueCode;
      this.referenceVal = this.checkRelation === 1 ? 'Friend' : 'Colleague';
      this.questionnaireId = q.questionnaireId;
      this.pager.count = this.checkRelation === 1 ? 11 : 15;
      this.show = this.pager.count > 1 ? false : true;
      return {
     ...q,
    inputType:  this.quizService.determineInputType(q)
    };

    });
  });
}
  loadQuiz(uniqueCode: string) {
    this.quizService.GetService(uniqueCode).subscribe(res => {
      let CheckId = res[0].QuestionnaireId;
      this.questionaryID = res[0].QuestionnaireId;
      let Pid = res[0].ProfileId;
      this.GetProjectCompanies(Pid); 
      this.quizService.GetProfile(Pid).subscribe(res2 => {
        this.name = res2;
      })

      //this.quiz = new Quiz(res);
      //this.showres = true;
      //this.completeQuiz = new CompleteQuiz(res);
      //this.pager.count = this.quiz.QuestionTypeList.length;
      //this.pager.count = this.completeQuiz.Quiz.length;
      

    });
  }

  changeRoute() {
    window.location.href = 'https://arytic.co';
  }

  // onChange(val) {
  //   // this.relationStored()

  //   if (val == 5) {
  //     this.toastr.successToastr('Thank you for Information', 'Ohh!');
  //     //this.submitRef = new InsertReferences();
  //     sessionStorage.removeItem('refId');
  //     window.location.href = 'https://arytic.com/';
  //   } else if (this.checkRelation === 1 && this.referenceVal) {
  //     this.goToFirstPersonalQuestion();
  //   }
  //   // For professional reference, we don't immediately show questions
  //   // The role dropdown will appear and onRoleChange will handle navigation to questions
  // }
  
  // goToFirstPersonalQuestion() {
  //   // Reset to the first step/question for personal reference
  //   this.pager.index = 0;
  //   this.mode = 'quiz';
  //   this.show = false;
  //   this.config.allowBack = false;
  //   this.showres = true; // Show the questions
  // }

  // goToFirstProfessionalQuestion() {
  //   // Reset to the first step/question for professional reference
  //   this.pager.index = 0;
  //   this.mode = 'quiz';
  //   this.show = false;
  //   this.config.allowBack = false;
  //   this.showres = true; // Show the questions
  // }

  // onRoleChange(val) {
  //   console.log('Role changed:', val);
    
  //   // Only proceed if a valid role is selected (not empty or undefined)
  //   if (val && val !== "" && val !== undefined) {
  //     // Store the role selection
  //     this.role = val;
      
  //     // Now that both the reference type and role are selected, go to questions
  //     if (this.checkRelation ===1  && this.referenceVal) {
  //       this.goToFirstProfessionalQuestion();
  //     } else {
  //       this.showres = true;
  //     }
  //   }
  // }
  
  // Reset role selection when going back
  // goBackToRelation() {
  //   this.showres = false;
  //   this.referenceVal = undefined;
  //   this.roleSelection = undefined;
  // }



  // changeModel(newName: string) {
  //   this.others = newName;
  //   this.role = this.others;
  // }

  // Select1(val) {
  //   if (val == 1) {

  //     if (this.role1 != "Others") {
  //       this.OtherSelect = false;
  //       this.role = this.role1;
  //     }
  //     else {
  //       this.OtherSelect = true;

  //     }

  //   }
  //   else if (val == 2) {

  //     if (this.role2 != "Others") {
  //       this.OtherSelect = false;
  //       this.role = this.role2;
  //     }
  //     else {
  //       this.OtherSelect = true;

  //     }
  //   }
  //   else if (val == 3) {
  //     if (this.role3 != "Others") {
  //       this.OtherSelect = false;
  //       this.role = this.role3;
  //     }
  //     else {
  //       this.OtherSelect = true;

  //     }


  //   }

  //   else {
  //     this.OtherSelect = true;

  //   }
  // }
// goTo(index: number) {
//     this.pager.index = index;
//   }

  onChangeCompany(value: any) {
    if (value === '__custom__') {
      this.isCustomCompany = true;
      this.answers[this.questions[this.pager.index].questionId] = '';
    } else {
      this.isCustomCompany = false;
      this.answers[this.questions[this.pager.index].questionId] = value;
    }
  }

goTo(index: number): void {
  const safeIndex = Math.max(0, Math.min(index, this.pager.count - 1));
  this.pager.index = safeIndex;
  this.show = safeIndex === this.pager.count - 1;
}

getAnswerKey(questionId: number, skill: string): string {
  return `${questionId}-${skill}`;
}

showProficiencyLevels(): void {
  this.showProficiencyLevelsFlag = !this.showProficiencyLevelsFlag;
}

 toTitleCase(text: string): string {
  if (!text) return '';
  return text
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}



handleSubmit(form: NgForm) {
  if (!form.valid) return;

  // If not on last page, go to next
  if (this.pager.index < this.pager.count - 1) {
    this.goTo(this.pager.index + 1);
    return;
  }

  // Final page: loop through and post each answer individually
  this.questions.forEach((q) => {
    const baseAnswer = this.answers[q.questionId];
    const isRatingMatrix = q.inputType === 'rating' && Array.isArray(q.answerChoiceList);
    const isSkillRating = q.questionNumber === 14 || q.questionNumber === 15;

if (isSkillRating && isRatingMatrix) {
const selectedAnswerString = q.answerChoiceList
  .map((skill: string) => {
    const answer = this.answers[`${q.questionId}-${skill}`];
    return `${skill}:${answer || ''}`; // fallback-safe
  })
  .join(';');

  const payload = {
    uniqueCode: this.uniqueCode,
    questionnaireId: this.questionnaireId,
    relation: this.relation,
    questionId: q.questionId,
    selectedAnswer: selectedAnswerString, // ✅ string format
    additionalComments: '', // optional
    isFinalSubmission: true
  };

  this.quizService.PostRefService(payload).subscribe({
    next: (res) => console.log(`Saved Q${q.questionId}`, res),
    error: (err) => console.error(`Error saving Q${q.questionId}`, err)
  });
}else {
      const payload = {
        uniqueCode: this.uniqueCode,
        questionnaireId: this.questionnaireId,
        relation: this.relation,
        questionId: q.questionId,
        selectedAnswer: baseAnswer,
        additionalComments: '',
        isFinalSubmission: true
      };
      this.quizService.PostRefService(payload).subscribe();
    }
  });

  // Final success message after all posts
  const referenceType = this.checkRelation === 1  ? "Personal" : "Professional";
  const firstName = this.name.ProfileBasicInfo.FirstName || '';
  const lastName = this.name.ProfileBasicInfo.LastName || '';
const fullName = this.toTitleCase((firstName + ' ' + lastName).trim());

  Swal("Reference Completed", `You have completed the ${referenceType} Reference for ${fullName}.`, "success")
    .then(() => {
      window.location.href = 'https://arytic.co';
    });
}


  GetProjectCompanies(ProfileId) {
    this.quizService
      .GetCompanies(
        ProfileId
      )
      .subscribe((ta) => {
        this.companyList = ta;
      });

  }


  GetReferenceReasons(code)
  {
   this.quizService
      .GetReferenceResults(
        code
      )
      .subscribe((ta:any) => {
        if(ta.length > 0)
        {
           Swal("Reference Completed", `You have completed the Already.`, "success")
    // .then(() => {
    //   window.location.href = 'https://arytic.co';
    // });
        }
      });
  }


  // get filteredQuestions() {
  //   return (this.quiz.QuestionTypeList) ?
  //     this.quiz.QuestionTypeList.slice(this.pager.index, this.pager.index + this.pager.size) : [];
  // }
  // get filteredQuestions() {
  //   return (this.completeQuiz.Quiz) ?
  //     this.completeQuiz.Quiz.slice(this.pager.index, this.pager.index + this.pager.size) : [];
  // }
  // onNext(val)
  // {
  // this.showQstns=true;
  // }
  // onSave(val)
  // {
  //   this.email=val;
  // }
  // onSelect(question: Question, option: QuestionList, ans: any, response?: string) {
  //   console.log("ddddddd",question,option,ans,response)
  //   //  if (question.QuestionTypeId === 1) {
  //   //let response=new SaveReferenceApproval();
  //   // this.response.QuestionnaireId= this.quiz.QuestionnaireId;
  //   // this.response.uniqueCode=sessionStorage.getItem("refId");
  //   question.QuestionList.forEach(
  //     (x) => {
  //       // let qResponses=  new QuestionnaireResponses();
  //       if (x.QuestionId === option.QuestionId) {
  //         if (response === undefined) {
  //           x.Answer = ans;
  //         }
  //         x.ResponseValue = response;
  //         if(question.QuestionTypeId == 8 && option.QuestionId == 123){

  //         }
  //   console.log("ddddddd",question,option,ans,response )
  //   console.log("ddddddddddddd",question,option,ans,response,x.ResponseValue )

  //         //   qResponses.QuestionId=option.QuestionId;
  //         //   if(question.QuestionTypeId === 9 || 8){
  //         //   qResponses.ResponseId=parseInt(option.Answer,10);
  //         //   qResponses.ResponseValue='';
  //         //   }else{
  //         //     qResponses.ResponseValue= option.Answer;
  //         //     qResponses.ResponseId=null;
  //         //   }
  //         // this.response.ListCandidateReferenceDetails.push(qResponses)
  //       }
  //     }

  //   );
  //   // }

  //   if (this.config.autoMove) {
  //     this.goTo(this.pager.index + 1);
  //   }
  // }
  // changeAnswer(value: string, id: number) {
  //         for (let i in this.questionList) {
  //             if (this.questionList[i].Id === id) {
  //                 this.questionList[i].ModifiedAnswers = value;
  //                 break;
  //             }
  //         }
  //     }
  // goTo(index: number) {
  //   //if(this.f.valid){
  //   if (index >= 0 && index < this.pager.count) {
  //     this.pager.index = index;
  //     this.mode = 'quiz';
  //     this.show = false;
  //     //if(){
  //     this.config.allowBack = index === 0 ? false : true
  //     //}
  //   }
  //   if (index > 0 && index === this.pager.count - 1) {
  //     this.show = true;
  //     //this.config.allowBack=false;
  //   }
  //   //}

  // }

  // // Original goBackToRelation removed - replaced by enhanced version
  // surveyComplete()
  // {
  //    let response=new SaveReferenceApproval();
  //   this.response.QuestionnaireId= this.quiz.QuestionnaireId;
  //   this.response.uniqueCode= '7AC0E0';//sessionStorage.getItem("refId");
  //   this.quiz.QuestionTypeList.forEach(
  //     (x) => {

  //       x.QuestionList.forEach((y) => {
  //         let qResponses=  new QuestionnaireResponses();
  //       //if (y.QuestionId === option.QuestionId) {
  //          // y.Answer = option.Answer;
  //           qResponses.QuestionId=y.QuestionId;
  //           if(x.QuestionTypeId === 9 || x.QuestionTypeId === 8){
  //           qResponses.ResponseId= y.Answer.length > 0 ? parseInt(y.Answer,10) : null;
  //           qResponses.ResponseValue=null;
  //           }else{
  //             qResponses.ResponseValue= y.Answer;
  //             qResponses.ResponseId=null;
  //           }
  //         this.response.ListCandidateReferenceDetails.push(qResponses)
  //       //}
  //     });
  //   });
  //   this.quizService.PostService(this.response)
  //           .subscribe(data => {
  //               alert(data);
  //               //this.submitRef = new InsertReferences();
  //               sessionStorage.removeItem('refId');
  //               // if (this.loggedinUser != null) {
  //               //     this.router.navigateByUrl('dashboard');
  //               // } else {
  //               //     this.router.navigateByUrl('login');
  //               // }
  //           });


  // }
  relationStored()
  {
    console.log("relationStored() called");
    const data = {
      uniqueCode:this.quizName,
    QuestionnaireId: this.questionaryID,
    relation:this.referenceVal
    }
    console.log("dataaaa",data);
    this.quizService.postRelation(data).subscribe(
      (v:any) => {
        // window.location.href = 'https://www.arytic.com';
        
        console.log("post Relation success:", v);
        console.log("About to show SweetAlert");
        
        // Determine reference type and full name
        const referenceType = this.checkRelation === 1 ? "Personal" : "Professional";
        const firstName = this.name && this.name.ProfileBasicInfo ? this.name.ProfileBasicInfo.FirstName : '';
        const lastName = this.name && this.name.ProfileBasicInfo ? this.name.ProfileBasicInfo.LastName : '';
        const fullName = (firstName + ' ' + lastName).trim();
        
        Swal("Reference Completed", "You have completed the " + referenceType + " Reference for " + fullName + ".", "success")
        .then(() => {
          window.location.href = 'https://www.m';
        });
      

      },
      error => {
        console.error("postRelation error:", error);
        // Show alert even if postRelation fails
        console.log("About to show SweetAlert after error");
        
        // Determine reference type and full name
        const referenceType = this.checkRelation ? "Personal" : "Professional";
        const firstName = this.name && this.name.ProfileBasicInfo ? this.name.ProfileBasicInfo.FirstName : '';
        const lastName = this.name && this.name.ProfileBasicInfo ? this.name.ProfileBasicInfo.LastName : '';
        const fullName = (firstName + ' ' + lastName).trim();
        
        Swal("Reference Completed", "You have completed the " + referenceType + " Reference for " + fullName + ".", "success")
        .then(() => {
          window.location.href = 'https://www.m';
        });
      }
    )
  }

  surveyComplete() {
    console.log("surveyComplete() called");
    
    let response = new SaveReferenceApproval();
    this.response.ListCandidateReferenceDetails = [];
    this.completeQuiz.Quiz.forEach((z) => {
      this.response.QuestionnaireId = z.QuestionnaireId;
      this.response.uniqueCode = sessionStorage.getItem("refId");
      z.QuestionTypeList.forEach(
        (x) => {
          let answers = [];
          // x.QuestionList.forEach(x => answers.push({ 'QuizId': this.quiz.QuestionnaireId, 'QuestionId': x.QuestionId, 'Answered': x.Answers }));
          // debugger
          x.QuestionList.forEach((y) => {
            let qResponses = new QuestionnaireResponses();
            //if (y.QuestionId === option.QuestionId) {
            // y.Answer = option.Answer;
            qResponses.QuestionId = y.QuestionId;
            if (x.QuestionTypeId === 9 || x.QuestionTypeId === 8) {
              qResponses.ResponseId = y.Answer != null ? parseInt(y.Answer, 10) : null;
              qResponses.ResponseValue = qResponses.ResponseId + "";
            }
            else if (x.QuestionTypeId == 18) {
              qResponses.ResponseId = parseInt(y.Answer, 10);
              qResponses.ResponseValue = this.others;
            }
            else if (x.QuestionTypeId == 6 && y.QuestionId == this.radioSelected7) {
              qResponses.ResponseId = parseInt(y.Answers, 10);
              qResponses.ResponseValue = y.Question;
            }
            else if (x.QuestionTypeId == 6 && y.QuestionId == this.radioSelected8) {
              qResponses.ResponseId = parseInt(y.Answers, 10);
              qResponses.ResponseValue = y.Question;
            }
            else if (x.QuestionTypeId == 6 && y.QuestionId == this.radioSelected9) {
              qResponses.ResponseId = parseInt(y.Answers, 10);
              qResponses.ResponseValue = y.Question;
            }
            else if (x.QuestionTypeId == 6 && y.QuestionId == this.radioSelected10) {
              qResponses.ResponseId = parseInt(y.Answers, 10);
              qResponses.ResponseValue = y.Question;
            }
            else if (x.QuestionTypeId == 6 && y.QuestionId == this.radioSelected11) {
              qResponses.ResponseId = parseInt(y.Answers, 10);
              qResponses.ResponseValue = y.Question;
            }
            else if (qResponses.QuestionId > 129) {

              if (qResponses.QuestionId == 130) {
                qResponses.ResponseId = parseInt(y.Answers, 10);
              }
              else if (qResponses.QuestionId == 131) {
                qResponses.ResponseId = 7
              }
               else if (qResponses.QuestionId == 132) {
                qResponses.ResponseId = 13
              } 
              else if (qResponses.QuestionId == 133) {
                qResponses.ResponseId = 9
              }
              else if (qResponses.QuestionId == 134) {
                qResponses.ResponseId = 10
              }

              qResponses.ResponseValue = y.ResponseValue + "";
            }
            else {
              qResponses.ResponseValue = y.Answer + "";
              qResponses.ResponseId = null;
            }
            this.response.ListCandidateReferenceDetails.push(qResponses)
            //}
          });
        });
    });
    // debugger
    console.log("response", this.response)
    this.quizService.PostService(this.response)
    .subscribe(
      data => {
        console.log("PostService success:", data);
        //alert(data);
        this.relationStored()
        // this.toastr.successToastr('You have Completed Successfully','Success!');
        //this.submitRef = new InsertReferences();
        sessionStorage.removeItem('refId');
        this.others = undefined;
        this.OtherSelect = false;
        // if (this.loggedinUser != null) {
        //     this.router.navigateByUrl('dashboard');
        // } else {
        //     this.router.navigateByUrl('login');
        // }
      },
      error => {
        console.error("PostService error:", error);
        // Show alert even if API call fails
        this.relationStored();
      }
    );



  }
  // isAnswered(index) {
  //   return this.quiz.questions[index].options.find(x => x.selected) ? 'Answered' : 'Not Answered';
  // };

  // isCorrect(question: Question) {
  //   return question.options.every(x => x.selected === x.isAnswer) ? 'correct' : 'wrong';
  // };

  // onSubmit() {
  //   let answers = [];
  //   this.quiz.questions.forEach(x => answers.push({ 'QuizId': this.quiz.id, 'QuestionId': x.id, 'Answered': x.answered }));

  //   // Post your data to the server here. answers contains the questionId and the users' answer.
  //   console.log(this.quiz.questions);
  //   this.mode = 'result';
  // }
}
export class SaveReferenceApproval {
  QuestionnaireId: number;
  uniqueCode: string;
  ListCandidateReferenceDetails: QuestionnaireResponses[] = [];
}
export class QuestionnaireResponses {
  ResponseId: number;
  QuestionId: number;
  ResponseValue: string;
  IsAnswered: string;
}


export class Profile {
  ProfileBasicInfo: Name;
}

export class Name {
  FirstName: string;
  LastName: string;
}
export class ReferenceQuestion {
  questionId!: number;
  questionNumber!: number;
  questionnaireId!: number;
  caption!: string;
  answerChoices!: string;
  answerChoiceList: string[] = []; // assuming choices are strings
  inputType: 'dropdown' | 'radio' | 'rating' | 'textarea' = 'dropdown'; // default value
}